import { createAction } from "redux-starter-kit";

import { NEXT_STEP } from "../types";

const moveToNextStep = () => createAction(NEXT_STEP)();

export default moveToNextStep;
